const AUTOCOMPLETE_URL = "https://places.googleapis.com/v1/places:autocomplete"
const AUTOCOMPLETE_FIELD_MASK = [
  "suggestions.placePrediction.placeId",
  "suggestions.placePrediction.text",
  "suggestions.placePrediction.types",
].join(",")

export async function fetchPlacePredictions(
  query,
  { apiKey, fetchImpl = fetch, includedPrimaryTypes = [], sessionToken } = {},
) {
  if (query === "") return []

  const body = { input: query }

  if (includedPrimaryTypes.length > 0) {
    body.includedPrimaryTypes = includedPrimaryTypes
  }

  if (sessionToken) {
    body.sessionToken = sessionToken
  }

  const response = await fetchImpl(AUTOCOMPLETE_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Goog-Api-Key": apiKey,
      "X-Goog-FieldMask": AUTOCOMPLETE_FIELD_MASK,
    },
    body: JSON.stringify(body),
  })
  const responseText = await response.text()
  let payload = {}

  try {
    payload = JSON.parse(responseText)
  } catch {
    // Preserve the HTTP status below when a proxy returns HTML or an empty body.
  }

  if (!response.ok) {
    const detail =
      payload.error?.message || response.statusText || "Unknown error"
    throw new Error(
      `Places autocomplete failed (${response.status}): ${detail}`,
    )
  }

  return (payload.suggestions || [])
    .map((suggestion) => suggestion.placePrediction)
    .filter((prediction) => prediction)
    .map((prediction) => ({
      ...prediction,
      types: prediction.types || [],
    }))
}
